import type { ReactNode } from 'react';
import React, { useCallback, useState } from 'react';

import { Mode } from 'app/components/commons/Hotel/Types';

type EditModeContextType = {
  mode: Mode;
  isEditMode: boolean;
  isViewMode: boolean;
  enterEditMode: () => void;
  enterViewMode: () => void;
};

const initialContext: EditModeContextType = {
  mode: Mode.View,
  isEditMode: false,
  isViewMode: true,
  enterEditMode: () => {
    /* no-op */
  },
  enterViewMode: () => {
    /* no-op */
  },
};

export const ViewEditModeContext =
  React.createContext<EditModeContextType>(initialContext);

type ViewEditModeProviderProps = {
  children: ReactNode;
};

export const ViewEditModeContextProvider = ({
  children,
}: ViewEditModeProviderProps) => {
  const [mode, setModeState] = useState<Mode>(Mode.View);

  const setMode = useCallback((newMode: Mode) => {
    setModeState(newMode);
  }, []);

  const enterEditMode = useCallback(() => {
    setMode(Mode.Edit);
  }, [setMode]);

  const enterViewMode = useCallback(() => {
    setMode(Mode.View);
  }, [setMode]);

  const value: EditModeContextType = {
    mode,
    isEditMode: mode === Mode.Edit,
    isViewMode: mode === Mode.View,
    enterEditMode,
    enterViewMode,
  };

  return (
    <ViewEditModeContext.Provider value={value}>
      {children}
    </ViewEditModeContext.Provider>
  );
};
